import { IconButton, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import BorderColorIcon from '@mui/icons-material/BorderColor';

export default function QuestionCategoriesDataGrid({
  rows,
  activateCategory,
  deactivateCategory,
  handleEditCategory,
}) {
  const columnsQuestionCategories = [
    { field: 'description', headerName: 'Περιγραφή', flex: 1 },
    {
      field: '',
      headerName: 'Ενέργειες',
      flex: 0.5,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      type: 'boolean',
      editable: true,
      valueGetter: (params) => params.row.is_active ?? true,
      renderCell: (params) => (
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <IconButton
            onClick={() => handleEditCategory(params.row)}
            sx={{
              cursor: 'pointer',
              color: 'primary.dark',
              transition: 'background-color 0.3s, color 0.3s',
              padding: '12px',
              borderRadius: '50%',
              '&:hover': {
                backgroundColor: 'grey.300',
              },
            }}
            aria-label="edit user"
          >
            <BorderColorIcon />
          </IconButton>
          {params.row.is_active === 1 ? (
            <IconButton
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                deactivateCategory(params.row.id);
              }}
            >
              <ToggleOffIcon fontSize="large" color="success" />
            </IconButton>
          ) : (
            <IconButton
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                activateCategory(params.row.id);
              }}
            >
              <ToggleOnIcon color="error" fontSize="large" />
            </IconButton>
          )}
        </Box>
      ),
    },
  ];

  return (
    <>
      <DataGrid
        sx={{
          '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none !important',
          },
          pb: 3,
          '&.MuiDataGrid-root': {
            border: 'none',
          },
          '.MuiDataGrid-columnSeparator': {
            display: 'none',
          },
          '& .MuiDataGrid-columnHeaders': {
            borderTop: '1px solid black',
            borderBottom: '1px solid black',
            borderRadius: 0,
          },
        }}
        rows={rows}
        columns={columnsQuestionCategories}
        disableColumnMenu
        disableRowSelectionOnClick
        disableColumnFilter
        hideFooter
      />
    </>
  );
}
